export const selectorChartCartesianAxisState = state => state.cartesianAxis;
export const selectorChartRawXAxis = state => state.cartesianAxis?.x;
export const selectorChartRawYAxis = state => state.cartesianAxis?.y;